import resetHooks from "./reset-hooks";
import setAlternateData from "./set-alternate-data";

/**
 * Increase offset timeline iteration count
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @param {Boolean} enter
 * @param {Number} iteration
 */
const increaseOffsetIteration = (trigger, timeline, enter, iteration) => {
  /** Timeline has "alternate" direction */
  const alternate = /** @type {Number} */ (timeline.get("has-alternate"));
  const steps = /** @type {Array<StepProps>} */ (timeline.get("steps"));

  timeline.set("is-iterating", true);

  if (alternate) {
    setAlternateData(trigger, timeline, steps, enter, iteration);
  } else {
    if (enter) {
      timeline.set("enter-time", null);
      timeline.set("current-iteration", ++iteration);

      resetHooks(steps);
    }
  }
};

export default increaseOffsetIteration;
